var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgConnector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.11,32.32A18.21,18.21,0,0,1,29,.46l.36-.33L30,0H52.72l.36.32A18.4,18.4,0,0,1,59.39,14,18.31,18.31,0,0,1,41.11,32.32ZM30.88,3.62a14.67,14.67,0,1,0,20.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,17.12A2.91,2.91,0,1,1,44,14.21,2.9,2.9,0,0,1,41.1,17.12Zm0-4.77A1.87,1.87,0,1,0,43,14.21,1.87,1.87,0,0,0,41.1,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14,17.3a3.09,3.09,0,1,1,3.09-3.09A3.09,3.09,0,0,1,32.14,17.3Zm0-5.15a2.06,2.06,0,1,0,2.06,2.06A2.06,2.06,0,0,0,32.14,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,44a5.18,5.18,0,1,1,5.17-5.18A5.19,5.19,0,0,1,48.08,44Zm0-8.51a3.34,3.34,0,1,0,3.33,3.33A3.34,3.34,0,0,0,48.08,35.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7,44a5.18,5.18,0,1,1,5.18-5.18A5.18,5.18,0,0,1,34.7,44Zm0-8.51A3.34,3.34,0,1,0,38,38.79,3.34,3.34,0,0,0,34.7,35.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.76,24.83a3.1,3.1,0,1,1,3.09-3.1A3.09,3.09,0,0,1,36.76,24.83Zm0-5.15a2.06,2.06,0,1,0,2.06,2.05A2.05,2.05,0,0,0,36.76,19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,24.83a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,46,24.83Zm0-5.15a2.06,2.06,0,1,0,2.06,2.05A2.05,2.05,0,0,0,46,19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.22,17.3a3.09,3.09,0,1,1,3.09-3.09A3.09,3.09,0,0,1,50.22,17.3Zm0-5.15a2.06,2.06,0,1,0,2.06,2.06A2.07,2.07,0,0,0,50.22,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,9.87a1.95,1.95,0,1,1,2-1.95A1.95,1.95,0,0,1,37,9.87ZM37,7a.92.92,0,1,0,.92.92A.92.92,0,0,0,37,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,9.87a1.95,1.95,0,1,1,2-1.95A1.94,1.94,0,0,1,46,9.87ZM46,7a.92.92,0,1,0,.92.92A.92.92,0,0,0,46,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.29,46.56H30.92a7.5,7.5,0,0,1-7.5-7.5v-.53a7.5,7.5,0,0,1,7.5-7.5H51.29a7.51,7.51,0,0,1,7.5,7.5v.53A7.51,7.51,0,0,1,51.29,46.56ZM30.92,32.51a6,6,0,0,0-6,6v.53a6,6,0,0,0,6,6H51.29a6,6,0,0,0,6-6v-.53a6,6,0,0,0-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.08,30s.83,1.51.29,2.05,7.73.32,7.73.32V30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.51,29.82s-.83,1.51-.29,2.05-7.73.32-7.73.32V29.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.47,64A8.52,8.52,0,0,1,30,62.84a5.27,5.27,0,0,1-2.46-5.53c.81-2.89.67-4.91-.35-6.05a4.59,4.59,0,0,0-3.06-1.21H6.56a1.75,1.75,0,1,1,0-3.48H24.08a8.68,8.68,0,0,1,6.15,2.51c1.84,2.05,2.23,5,1.14,8.89a1.89,1.89,0,0,0,.88,2,5.42,5.42,0,0,0,4.69,0,2.63,2.63,0,0,0,1.78-2.32l0-10.39a2,2,0,0,1,3.9,0l0,10.39c0,2.3-1.42,4.27-3.88,5.41A10.27,10.27,0,0,1,34.47,64Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.14,
    cy: 14.21,
    r: 1.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.11,
    cy: 14.21,
    r: 1.03
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.22,
    cy: 14.21,
    r: 1.03
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.01,
    cy: 21.73,
    r: 1.03
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.76,
    cy: 21.73,
    r: 1.03
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.01,
    cy: 7.92,
    r: 0.56
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 7.92,
    r: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConnector1);
export default __webpack_public_path__ + "static/media/img_connector_1.d625d03cad41992c1ec30e219321d5ce.svg";
export { ForwardRef as ReactComponent };